
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const toolprofileApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listToolProfiles: builder.query ({
      query: (params) => `v2/toolprofile/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["ToolProfile"]
    }),
    getToolProfile: builder.query ({
      query: (toolprofile_id) => `v2/toolprofile/${toolprofile_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["ToolProfile"]
    }),

    updateToolProfile: builder.mutation ({
      query: ({toolprofile_id, data}) => ({
        url: `v2/toolprofile/${toolprofile_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["ToolProfile"]
    }),
    deleteToolProfile: builder.mutation ({
      query: (toolprofile_id) => ({
        url: `v2/toolprofile/${toolprofile_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["ToolProfile"]
    }),
    createToolProfile: builder.mutation ({
      query: (data) => ({
        url: `v2/toolprofile/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ToolProfile"]
    }),
  })
})


export const {
  useListToolProfilesQuery,
  useLazyListToolProfilesQuery,
  useGetToolProfileQuery,
  useLazyGetToolProfileQuery,

  useUpdateToolProfileMutation,
  useDeleteToolProfileMutation,
  useCreateToolProfileMutation
} = toolprofileApi
